// UnderConstructionPage.jsx
import React from 'react';
import { FaTools, FaHardHat, FaChevronLeft } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const UnderConstructionPage = ({ returnPath = "/" }) => {
  return (
    <div className="min-h-screen bg-zinc-900 flex flex-col">
      {/* Main content */}
      <main className="flex-grow flex items-center justify-center p-4">
        <div className="max-w-3xl w-full bg-zinc-800 rounded-xl shadow-2xl overflow-hidden">
          <div className="h-4 bg-gradient-to-r from-red-500 via-red-600 to-red-700"></div>
          
          <div className="p-8 md:p-12 text-center">
            <div className="flex justify-center mb-8">
              <div className="relative">
                <FaTools className="text-red-500 text-7xl animate-pulse" />
                <FaHardHat className="absolute -top-6 -right-6 text-4xl text-yellow-500 transform rotate-12" />
              </div>
            </div>
            
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
              ¡Página En Construcción!
            </h2>
            
            <p className="text-gray-300 text-lg mb-8">
              Estamos trabajando para mejorar tu experiencia. Esta sección pronto estará disponible con nuevas y emocionantes funcionalidades.
            </p>
            
            
            
            <Link 
              to={returnPath}
              className="inline-flex items-center px-6 py-3 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors shadow-lg"
            >
              <FaChevronLeft className="mr-2" />
              Volver a Pagina Principal
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
};

export default UnderConstructionPage;